import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
const SVG = ({
  className = '',
  size = '24'
}) => ___EmotionJSX("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: size,
  height: size,
  className: className,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, ___EmotionJSX("polyline", {
  points: "5 9 2 12 5 15"
}), ___EmotionJSX("polyline", {
  points: "9 5 12 2 15 5"
}), ___EmotionJSX("polyline", {
  points: "15 19 12 22 9 19"
}), ___EmotionJSX("polyline", {
  points: "19 9 22 12 19 15"
}), ___EmotionJSX("line", {
  x1: "2",
  y1: "12",
  x2: "22",
  y2: "12"
}), ___EmotionJSX("line", {
  x1: "12",
  y1: "2",
  x2: "12",
  y2: "22"
}));
export default SVG;